import { api } from "..";
const endpoint = "/api/config";

export const getConfigList = async () => {
  return await api.get(`${endpoint}`);
};

export const getConfigById = async (id:number) => {
  return await api.get(`${endpoint}/${id}`);
};

export const getConfigByName = async (name:string) => {
  return await api.get(`${endpoint}/name/${name}`);
};

export const createConfig = async (data:any) => {
  return await api.post(`${endpoint}`, data);
};

export const updateConfig = async (id:number, data:any) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteConfig = async (id:number) => {
  return await api.delete(`${endpoint}/${id}`);
}; 